// redux/reducers/services.js
import {
  GET_SERVICES_REQUEST,
  GET_SERVICES_SUCCESS,
  GET_SERVICES_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  loading: false,
  services: [],
  error: null,
};

export default function servicesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SERVICES_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_SERVICES_SUCCESS:
      return { loading: false, services: action.payload, error: null };
    case GET_SERVICES_FAILURE:
      return { loading: false, services: [], error: action.payload };
    default:
      return state;
  }
}
